import { render } from "./BalAlert.vue?vue&type=template&id=165da9d7&scoped=true&ts=true"
import script from "./BalAlert.vue?vue&type=script&lang=ts"
export * from "./BalAlert.vue?vue&type=script&lang=ts"

import "./BalAlert.vue?vue&type=style&index=0&id=165da9d7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165da9d7"]])

export default __exports__